import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { dayLabel } from "./socialMeta";

export const TopicDialog = ({ date, open, onClose, onSaved }) => {
  const [items, setItems] = useState([]);
  const [choice, setChoice] = useState("");
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    setChoice(""); setTitle(""); setDetails("");
    api.get("/admin/social/topics").then(({ data }) => setItems(data.items || [])).catch((e) => toast.error(apiError(e)));
  }, [open]);

  const save = async () => {
    const [kind, ...rest] = choice.split("::");
    setBusy(true);
    try {
      await api.put(`/admin/social/posts/${date}/topic`, kind === "custom" ? { kind, title, details } : { kind, ref_id: rest.join("::") });
      toast.success("Sujet du jour modifié");
      onSaved(); onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="social-topic-dialog" className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Changer le sujet — {date && dayLabel(date)}</DialogTitle>
          <DialogDescription>Choisissez un sujet de la base Nold Go ou écrivez une actualité.</DialogDescription>
        </DialogHeader>
        <select data-testid="social-topic-select" value={choice} onChange={(e) => setChoice(e.target.value)}
          className="w-full h-11 rounded-xl border border-[#E2DFD8] bg-white px-3 text-sm">
          <option value="">— Sélectionner un sujet —</option>
          <option value="custom::">✎ Actualité personnalisée</option>
          {items.map((c) => <option key={`${c.kind}::${c.ref_id}`} value={`${c.kind}::${c.ref_id}`}>{c.label}</option>)}
        </select>
        {choice.startsWith("custom::") && (
          <div className="space-y-2">
            <Input data-testid="social-topic-title" placeholder="Titre (ex : Nouveau restaurant à Ixelles)" value={title} onChange={(e) => setTitle(e.target.value)} maxLength={120} />
            <Textarea data-testid="social-topic-details" placeholder="Détails et faits à mettre en avant (l'IA n'invente rien d'autre)" value={details} onChange={(e) => setDetails(e.target.value)} maxLength={600} rows={4} />
          </div>
        )}
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="outline" onClick={onClose} data-testid="social-topic-cancel">Annuler</Button>
          <Button data-testid="social-topic-save" disabled={busy || !choice || (choice.startsWith("custom::") && !title.trim())} onClick={save}
            className="bg-[#F26419] hover:bg-[#D8531E] text-white">Enregistrer</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
